import setCrisisAllocation from './setCrisisAllocation';
import setCrisisCalls from './setCrisisCalls';
import setAllocatedClients from './setAllocatedClients';

export default {
  setCrisisAllocation,
  setCrisisCalls,
  setAllocatedClients,
};
